// extracted by mini-css-extract-plugin
export default {"subscribe":"subscribe_subscribe__P7SVG","primary":"subscribe_primary__RA5Jo","btn-socials":"subscribe_btn-socials__L2Z65"};